// Order-summary helpers
// Service fee removed — customers pay the base package price.
export const SERVICE_FEE_PCT = 0.0;

export function calcServiceFee() {
  return 0;
}

export function calcTotal(price) {
  if (!price && price !== 0) return 0;
  return Math.round(price * 100) / 100;
}

// Convert "5-7 days" / "10-14 days" / "14 days" -> max days
export function turnaroundMaxDays(turnaround) {
  if (!turnaround) return 7;
  const nums = (turnaround.match(/\d+/g) || []).map(Number);
  if (!nums.length) return 7;
  return Math.max(...nums);
}

export function estimatedCompletionDate(turnaround) {
  const d = new Date();
  d.setDate(d.getDate() + turnaroundMaxDays(turnaround));
  return d.toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" });
}
